import { render, staticRenderFns } from "./CareCard.vue?vue&type=template&id=56c70c2c&scoped=true"
import script from "./CareCard.vue?vue&type=script&lang=js"
export * from "./CareCard.vue?vue&type=script&lang=js"
import style0 from "./CareCard.vue?vue&type=style&index=0&id=56c70c2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c70c2c",
  null
  
)

export default component.exports